module.exports = __webpack_public_path__ + "img/stock0.0766b172.png";